<template>
    <div id="app">

        <!--load banner-->
        <banner v-if="isBanner && !isPlugin"></banner>

        <div class="wrapper pull-right" v-if="!isHideAll">

            <!--load sidebar-->
            <sidebar v-if="!isPlugin"></sidebar>

            <div class="main-container" v-bind:class="{ plugin_main: isPlugin}">
                <!--load navbar-->
                <navbar container="container-fluid" v-if="!(isPlugin || isHideMainMenu)">
                    <li class="navbar-notification" slot="leftNavItems">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="true"
                           v-bind:title="$t('message_management.menu_title')" style="font-size: 14px">
                            <i class="far fa-lg fa-bell"></i>
                            <span class="caret"></span>
                            <span id="lblMessage1" v-if="unSeenMessagesCount>0" class="label messageCount label-danger">{{unSeenMessagesCount}}</span>
                        </a>
                        <ul class="dropdown-menu" role="menu">
                            <li class="text-center">
                                <router-link class="text-center" to="/message-grid/true">
                                    {{$t("context.view_received_messages")}}
                                </router-link>
                                <router-link class="text-center" to="/message-grid/false">
                                    {{$t("context.view_sent_message")}}
                                </router-link>
                            </li>
                            <li v-if="sendMessagePermission" class="divider"></li>
                            <li v-if="sendMessagePermission">
                                <router-link class="text-center" to="/send-message">
                                    {{$t("context.send_message")}}
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li slot="leftNavItems">
                        <a href="./Authentication/LogOut" v-bind:title="$t('sign_out')" style="font-size: 14px">
                            <i class="far fa-lg fa-power-off"></i>
                        </a>
                    </li>
                </navbar>

                <div class="container-fluid wrapper-padding">
                    <!--load pages here-->
                    <router-view></router-view>

                    <footer v-if="!isPlugin  && showFooter" style="padding:5px">
                        <small class="js_number">
                            &copy;{{$t('footer.rights')}}
                        </small>
                        <br />
                        <!--<small class="js_number">-->
                        <a class="js_number" :href="$t('footer.url')" target="_blank">{{$t('footer.powered_by_raybpms')}}</a>
                        <!--</small>-->
                    </footer>
                </div>
            </div>
            <div class="scroll-top" style="display: table;">
                <div style="margin: auto; display: table-cell; vertical-align: middle; text-align: center;"><i class="far fa-2x fa-chevron-up"></i></div>
            </div>
        </div>

        <div class="wrapper pull-right" v-if="isHideAll">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    import Banner from './component/banner/banner.vue';
    import Navbar from './component/navbar/navbar.vue';
    import Login from './component/login/login.vue';
    import Sidebar from './component/sidebar/sidebar.vue';
    import { App } from './assets/ts/global';
    import hubProxy from './assets/ts/signalr';

    const app = new App();

    export default {
        data() {
            return {
                isBanner: payload.isBanner,
                bodyBackground: payload.bodyBackground,
                unSeenMessagesCount: payload.unSeenMessagesCount,
                sendMessagePermission: payload.sendMessagePermission,
                isPlugin: payload.isPlugin,
                isHideMainMenu: payload.isHideMainMenu,
                isHideFormHeader: payload.isHideFormHeader,
                isHideFormToolbar: payload.isHideFormToolbar,
                isHideAll: payload.isHideAll
            }
        },
        computed: {
            showFooter() {
                return !payload.hideFooter
            }
        },
        mounted() {
            var self = this;
            this.$root.$on('ReloadMessageCount', () => {

                utils.callWebServicenopi("WebServices/MessageService.asmx", "GetUnSeenMessagesCount", {})
                    .done(function (data) {
                        self.unSeenMessagesCount = data.d;
                    });
            });
            setTimeout(function () {
                app.loadMethods();
            }, 1500)
        },
        methods: {
            showNotification(id, title, node) {
                var self = this;
                var dir = payload.currentLocale.IsRightToLeft == true ? 'rtl' : 'ltr';
                var options = {
                    body: title,
                    icon: "./dist/bpms-notif.png",
                    dir: dir,
                }

                Notification.requestPermission(function () {
                    var instance = new Notification(i18n.$t('new_message'), options);
                    instance.onclick = function (e) {
                        self.nodeSelect(node, node);
                    }
                    setTimeout(function () {
                        instance.close();
                    }, 4000);
                });
            }
        },
        components: {
            Banner,
            Navbar,
            Login,
            Sidebar
        }
    }

</script>
